import { Component } from '@angular/core';

@Component({
  selector: 'gc-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage {}
